// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pop-tips[data-v-004b5747] {\n  text-align: center;\n  line-height: 1.5;\n  margin-bottom: 20px;\n}\n.pop-tips .title[data-v-004b5747] {\n  font-size: 14px;\n  color: #2F3030;\n}\n.pop-tips .hot[data-v-004b5747] {\n  color: #D6223D;\n  font-size: 14px;\n}\n.form-item[data-v-004b5747] {\n  margin-bottom: 0;\n}", ""]);
// Exports
module.exports = exports;
